export default {
      id: "cake-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite.svg#cake",
      toString: function () {
        return this.url;
      }
    }